import React from "react";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

const FloatIcon = () => {
  return (
    <div className={styles.FloatIcon}>
      <Link to={"mailto:mahmoud.odah08@gmail.com"} >
        <img src={"/assets/images/gmail.svg"} alt={"Gmail"} />
      </Link>
      <Link to={"https://wa.me/00962770718344?text=Hello%20Mahmoud"} target="_blank">
        <img src={"/assets/images/whatsapp.svg"} alt={"Whatsapp"} />
      </Link>
    </div>
  );
};

export default FloatIcon;
